import { render, staticRenderFns } from "./CaratsTable.vue?vue&type=template&id=5e4f8814&"
import script from "./CaratsTable.vue?vue&type=script&lang=js&"
export * from "./CaratsTable.vue?vue&type=script&lang=js&"
import style0 from "./CaratsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports